// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"a5908ddd","621":"533360fb","743":"8412ba0f"}[chunkId] + ".chunk.js";
};